import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import Loader from "./Loader";
import { useWindowSize } from "./useWindowSize";

const Bar = React.memo(
  ({ onFinish, text, index }) => {
    const [loading, setLoading] = useState(true);
    const [canShowText, setCanShowText] = useState(false);
    const [lines] = useState(
      Array.isArray(text?.props?.children) ? text?.props?.children.length : 1
    );

    const textEl = useRef(null);

    const windowSize = useWindowSize();

    function handleCompletion() {
      setLoading(false);
      setTimeout(() => {
        onFinish();
      }, [800]);
    }

    useEffect(() => {
      if (!loading) {
        setTimeout(() => {
          setCanShowText(true);
        }, [200]);
      }
    }, [loading]);

    const duration = () => {
      let time;
      if (typeof text === "string") {
        time = text.length;
      }
      if (typeof text === "object") {
        if (Array.isArray(text?.props?.children)) {
          time = text?.props?.children.reduce(
            (acc, curr) => acc + curr.props?.children?.length,
            0
          );
        } else {
          time = text?.props?.children?.length;
        }
      }
      time = time * 40 + 200;
      return time / 1000;
    };

    const getHeight = () => {
      if (windowSize.width < 1000) {
        return 30 * lines;
      } else {
        return 44 * lines;
      }
    };

    const getWidth = () => {
      const el = textEl?.current?.getBoundingClientRect();
      const width = el?.width || 0;
      const padding = () => {
        if (windowSize.width < 1000) {
          return 20;
        } else {
          return 28;
        }
      };
      return width + padding();
    };

    return (
      <motion.div
        className="box-container"
        initial={{ x: -100, y: 30 }}
        animate={{ x: 0, y: 0, scale: [1, 1.1, 1] }}
        transition={{ duration: 0.5, ease: [0.68, 0.07, 0.28, 1.45] }}
      >
        <motion.div
          className="box"
          initial={{ width: "60px", height: "34px" }}
          animate={{ width: getWidth(), height: `${getHeight()}px` }}
          transition={{ duration: 0.2, ease: "easeInOut", delay: duration() }}
          onAnimationComplete={handleCompletion}
        >
          <Loader loading={loading} />
          <div
            ref={textEl}
            className={`text ${canShowText ? "done" : "loading"}`}
          >
            {text}
          </div>
        </motion.div>
      </motion.div>
    );
  },
  (prevProps, nextProps) => prevProps.index === nextProps.index
);

export default Bar;
